import React from "react";
import { IconButton, makeStyles, Tooltip } from "@material-ui/core";

const useStyles = makeStyles({
  iconButton: {
    borderRadius: "100%",
    zIndex: '1',
    height: "68px",
    width: "68px",
    background: "#fff",
    boxShadow: "0px 4px 24px rgba(85, 100, 119, 0.08)",
    margin: "10px",
    fill: "#4B617C",
    transition: "box-shadow 250ms ease",
    "&:hover": {
      background: "#fff",
      boxShadow: "0px 18px 32px rgba(0, 0, 0, 0.15)",
    },
    position: "absolute",
    top: "-34px",
    left: "10px",
    cursor: "pointer",
    outline: "none",
    '@media print': {
      boxShadow: 'none',
    }
  },
  enabled: {
    background: "linear-gradient(116.22deg, #009299 16.5%, #00B488 83.5%)",
    "&:hover": {
      background: "linear-gradient(116.22deg, #009299 16.5%, #00B488 83.5%)",
    },
    fill: "#fff",
  },
});
export default function UtilityButton(props) {
  const classes = useStyles();

  return (
    <Tooltip title={props.hoverItemTitle} placement="top">
      <IconButton
        className={`${classes.iconButton} ${props.isEnabled ? classes.enabled : ''}`}
        onClick={props.onClick}
      >
        {props.children}
      </IconButton>
    </Tooltip>
  );
}
